/* batida-v7-pages.js - the new batida.pl (27.09, Aleksandra's prototype _26): logic for three pages, each part runs
   only when its section is on the page. Loaded by sections/batida-v7-torty-hero, -galeria-hero, -legal-main.
   1. Torty: the enquiry card (sections/batida-v7-torty-form.liquid) - validation, inspiration photos to Cloudinary,
      and sending through the hidden Shopify contact form the cake wizard's way (BS-112, assets/batida-cake-wizard.js):
      that hidden form is the only one registered with Shopify.captcha.protect(); we fill it and requestSubmit() it,
      Shopify's callback does the native POST, the page comes back with ?contact_posted=true.
   2. Galeria (prototype _33): tag chips (all chosen tags must match) + tag search, big-photo view with arrows.
   3. Regulamin + polityki: table of contents from the text's headings, "you are here" highlight, print = PDF. */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function norm(s) { return String(s || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- 1. Torty: enquiry */
  function initTorty() {
    var root = $('[data-v7p-tq]');
    if (!root || root.hasAttribute('data-v7p-ready')) return;
    root.setAttribute('data-v7p-ready', '1');
    var form = $('[data-v7p-tf]', root);
    var sender = document.getElementById('v7p-torty-send');
    var ok = $('[data-v7p-ok]', root);
    if (!form || !sender) return;
    var D = root.dataset;

    /* back from Shopify with ?contact_posted=true: thank-you instead of the fields */
    if (/[?&]contact_posted=true/.test(location.search)) {
      form.classList.add('v7p-hide');
      if (ok) {
        ok.classList.remove('v7p-hide');
        setTimeout(function () {
          root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
          try { ok.focus({ preventScroll: true }); } catch (e) {}
        }, 150);
      }
      return;
    }
    if (/[?&]contact_posted=false/.test(location.search) || $('[data-v7p-err="send"]:not([hidden])', root)) {
      setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 150);
    }

    /* Spam check: register the hidden sender at load (cake wizard pattern). The armed flag stops the page-load
       callback from posting an empty form. */
    var armed = false;
    var protectedForm = false;
    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      try {
        window.Shopify.captcha.protect(sender, function () {
          if (armed) { armed = false; HTMLFormElement.prototype.submit.call(sender); }
        });
        protectedForm = true;
      } catch (e) {}
    }

    var el = {
      occ: $('#t-occ', root), date: $('#t-date', root), por: $('#t-por', root), pick: $('#t-pick', root),
      msg: $('#t-msg', root), name: $('#t-name', root), mail: $('#t-mail', root)
    };
    var btn = $('[data-v7p-sendbtn]', root);
    var sendErr = $('[data-v7p-err="send"]', root);

    function setErr(key, text) {
      var box = $('[data-v7p-err="' + key + '"]', root);
      var wrap = $('[data-v7p-f="' + key + '"]', root);
      if (box) { box.textContent = text || ''; box.hidden = !text; }
      if (wrap) wrap.classList.toggle('is-bad', !!text);
    }
    function isMail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v); }
    function isPhone(v) { return /^[+()\d\s.\-\/]+$/.test(v) && v.replace(/\D/g, '').length >= 9; }

    ['name', 'mail'].forEach(function (k) {
      el[k].addEventListener('input', function () { setErr(k === 'name' ? 'name' : 'contact', ''); });
    });

    /* ---- inspiration photos (Cloudinary unsigned upload, like the wizard; max 3, 10 MB each) ---- */
    var photos = [];
    var uploading = 0;
    var MAX = 3;
    var upWrap = $('[data-v7p-upwrap]', root);
    var fileIn = $('[data-v7p-file]', root);
    var upLabel = $('[data-v7p-up]', root);
    var thumbs = $('[data-v7p-thumbs]', root);
    var upErr = $('[data-v7p-uperr]', root);
    if (upWrap && !(D.cloud && D.preset)) upWrap.hidden = true;
    function upError(on) { if (upErr) { upErr.textContent = on ? D.errPhoto : ''; upErr.hidden = !on; } }
    function renderThumbs() {
      if (!thumbs) return;
      thumbs.innerHTML = '';
      photos.forEach(function (url, i) {
        var d = document.createElement('div'); d.className = 'v7p-tf__thumb';
        var img = document.createElement('img'); img.alt = ''; img.src = url.replace('/upload/', '/upload/w_144,h_144,c_fill/');
        var x = document.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', '×');
        x.addEventListener('click', function () { photos.splice(i, 1); renderThumbs(); });
        d.appendChild(img); d.appendChild(x); thumbs.appendChild(d);
      });
    }
    function busy() {
      if (upLabel) upLabel.classList.toggle('is-busy', uploading > 0);
      if (btn) btn.disabled = uploading > 0;
    }
    if (fileIn && D.cloud && D.preset) {
      fileIn.addEventListener('change', function () {
        var files = Array.prototype.slice.call(fileIn.files || []);
        fileIn.value = '';
        upError(false);
        files.forEach(function (f) {
          if (photos.length + uploading >= MAX || f.size > 10 * 1024 * 1024 || !/^image\//.test(f.type)) { upError(true); return; }
          uploading++; busy();
          var fd = new FormData();
          fd.append('file', f);
          fd.append('upload_preset', D.preset);
          fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(D.cloud) + '/image/upload', { method: 'POST', body: fd })
            .then(function (r) { return r.json(); })
            .then(function (j) { if (j && j.secure_url) photos.push(j.secure_url); else upError(true); })
            .catch(function () { upError(true); })
            .then(function () { uploading--; busy(); renderThumbs(); });
        });
      });
    }

    /* ---- send ---- */
    function fld(n) { return $('[data-v7p-fld="' + n + '"]', sender); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (uploading > 0) return;
      var name = norm(el.name.value);
      var contact = norm(el.mail.value);
      var bad = false;
      setErr('name', ''); setErr('contact', '');
      if (sendErr) { sendErr.hidden = true; sendErr.textContent = ''; }
      if (name.length < 2) { setErr('name', D.errName); bad = true; }
      var mail = isMail(contact);
      var phone = !mail && isPhone(contact);
      if (!mail && !phone) { setErr('contact', D.errContact); bad = true; }
      if (bad) {
        var first = $('.is-bad input', root);
        if (first) first.focus();
        return;
      }
      var occ = el.occ.value, date = norm(el.date.value), por = norm(el.por.value), pick = el.pick.value, idea = el.msg.value.trim();
      var page = location.origin + location.pathname;
      var body = [
        'ZAPYTANIE O TORT NA ZAMOWIENIE (strona: ' + page + ')',
        'Okazja: ' + (occ || '-'),
        'Termin: ' + (date || '-'),
        'Liczba porcji: ' + (por || '-'),
        'Odbior lub dostawa: ' + (pick || '-'),
        'Pomysl: ' + (idea || '-'),
        'Zdjecia inspiracji: ' + (photos.length ? '\n' + photos.join('\n') : '-'),
        '---',
        'Imie: ' + name,
        (mail ? 'E-mail: ' : 'Telefon (bez e-maila): ') + contact
      ].join('\n');

      fld('email').value = mail ? contact : (D.fallbackEmail || '');
      fld('name').value = name;
      fld('phone').value = phone ? contact : '';
      fld('occasion').value = occ;
      fld('portions').value = por;
      fld('date').value = date;
      fld('place').value = pick;
      fld('photos').value = photos.join('\n');
      fld('body').value = body;

      if (btn) { btn.disabled = true; btn.textContent = D.sending || btn.textContent; }
      if (protectedForm) armed = true;
      if (typeof sender.requestSubmit === 'function') sender.requestSubmit();
      else HTMLFormElement.prototype.submit.call(sender);
    });
  }

  /* ---------------------------------------------------------------- 2. Galeria: tags, search, big photo */
  function fold(x) { return String(x || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l'); }
  function initGaleria() {
    var root = $('[data-v7p-gl]');
    if (!root || root.hasAttribute('data-v7p-ready')) return;
    root.setAttribute('data-v7p-ready', '1');
    var items = $all('[data-v7p-gi]', root);
    var chips = $all('[data-v7p-gtag]', root);
    var q = $('[data-v7p-glq]');
    var none = $('[data-v7p-gnone]', root);
    var sel = [];
    items.forEach(function (it) {
      it._hay = fold((it.getAttribute('data-tags') || '').replace(/\|/g, ' ') + ' ' + (it.getAttribute('data-cap') || ''));
    });

    function apply(animate) {
      var words = fold(q ? q.value : '').split(/[\s,#]+/).filter(Boolean);
      var n = 0;
      items.forEach(function (it) {
        var tg = it.getAttribute('data-tags') || '';
        var ok = sel.every(function (k) { return tg.indexOf('|' + k + '|') !== -1; }) &&
                 words.every(function (w) { return it._hay.indexOf(w) !== -1; });
        var was = !it.hidden;
        it.hidden = !ok;
        if (ok) {
          /* a place without a photo (v7-ph-hidden) is invisible to visitors, so it does not count as a result */
          if (!it.classList.contains('v7-ph-hidden') || document.documentElement.classList.contains('v7-ph-on')) n++;
          if (animate && !reduced && !was) { it.classList.remove('is-in'); void it.offsetWidth; it.classList.add('is-in'); }
        }
      });
      if (none) none.hidden = n > 0;
      chips.forEach(function (c) {
        var k = c.getAttribute('data-v7p-gtag');
        c.setAttribute('aria-pressed', String(k === '' ? sel.length === 0 : sel.indexOf(k) !== -1));
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var k = c.getAttribute('data-v7p-gtag');
        if (k === '') sel = [];
        else if (sel.indexOf(k) !== -1) sel.splice(sel.indexOf(k), 1);
        else sel.push(k);
        apply(true);
      });
    });
    if (q) q.addEventListener('input', function () { apply(true); });

    /* /pages/galeria-realizacji#tag=Torty (or ?tag=Torty) opens with that chip on */
    var m = (location.hash + '&' + location.search).match(/[#&?]tag=([^&#]+)/);
    if (m) {
      var want = '';
      try { want = decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase().trim(); } catch (e) {}
      if (want && chips.some(function (c) { return c.getAttribute('data-v7p-gtag') === want; })) { sel = [want]; apply(false); }
    }

    /* big-photo view: only photos that are chosen and visible, arrows go round */
    var lb = $('[data-v7p-lb]', root);
    if (!lb) return;
    document.body.appendChild(lb);
    var img = $('[data-v7p-lbimg]', lb), cap = $('[data-v7p-lbcap]', lb), xBtn = $('[data-v7p-lbx]', lb);
    var idx = 0, last = null;
    function vis() { return items.filter(function (it) { return !it.hidden && $('[data-v7p-gopen]', it); }); }
    function show() {
      var v = vis();
      if (!v.length) return close();
      idx = (idx + v.length) % v.length;
      var it = v[idx], b = $('[data-v7p-gopen]', it), tags = $('figcaption span', it);
      img.src = b.getAttribute('data-src');
      img.alt = it.getAttribute('data-cap') || '';
      cap.textContent = (it.getAttribute('data-cap') || '') + (tags ? '  ·  ' + tags.textContent.replace(/ · /g, ' ') : '');
    }
    function open(it) {
      idx = vis().indexOf(it);
      last = document.activeElement;
      show();
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      xBtn.focus();
    }
    function close() {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      if (last && last.focus) last.focus();
    }
    items.forEach(function (it) {
      var b = $('[data-v7p-gopen]', it);
      if (b) b.addEventListener('click', function () { open(it); });
    });
    xBtn.addEventListener('click', close);
    $('[data-v7p-lbprev]', lb).addEventListener('click', function () { idx--; show(); });
    $('[data-v7p-lbnext]', lb).addEventListener('click', function () { idx++; show(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { idx++; show(); }
      else if (e.key === 'ArrowLeft') { idx--; show(); }
      else if (e.key === 'Tab') {
        var f = $all('button', lb), i = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
  }

  /* ---------------------------------------------------------------- 3. Regulamin: table of contents */
  var KEEP = { DPD: 'DPD', SMS: 'SMS', RODO: 'RODO', VAT: 'VAT', KRS: 'KRS', NIP: 'NIP', REGON: 'REGON', FOODS: 'Foods', BATIDA: 'Batida', BATIDY: 'Batidy', UE: 'UE', PL: 'PL' };
  /* "I. POSTANOWIENIA OGÓLNE" -> "I. Postanowienia ogólne" (labels in the list only; the text itself stays as it is) */
  function niceLabel(t) {
    if (t !== t.toUpperCase() || !/[A-ZĄĆĘŁŃÓŚŹŻ]{3}/.test(t)) return t;
    var words = t.split(' ');
    var out = words.map(function (w, i) {
      if (i === 0 && /^[IVXLC]+\.?$/.test(w)) return w;
      if (/^§/.test(w)) return w;
      var core = w.replace(/[^A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]/g, '');
      if (KEEP[core]) return w.replace(core, KEEP[core]);
      return w.toLocaleLowerCase('pl');
    }).join(' ');
    return out.replace(/^((?:[IVXLC]+\.\s*|§\s*\d+\.?\s*)?[^A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]*)([a-ząćęłńóśźż])/, function (m, a, b) { return a + b.toLocaleUpperCase('pl'); });
  }
  function boldText(p) {
    var s = '';
    var w = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var a = n.parentNode, b = false;
      while (a && a !== p) { if (a.nodeName === 'STRONG' || a.nodeName === 'B') { b = true; break; } a = a.parentNode; }
      if (b) s += n.nodeValue;
    }
    return norm(s);
  }
  function initLegal() {
    var root = $('[data-v7p-legal]');
    if (!root || root.hasAttribute('data-v7p-ready')) return;
    root.setAttribute('data-v7p-ready', '1');
    var rte = $('[data-v7p-rte]', root);
    var box = $('[data-v7p-tocbox]', root);
    var list = $('[data-v7p-toclist]', root);
    var printBtn = $('[data-v7p-print]', root);
    if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
    if (!rte || !box || !list) return;

    /* empty spacer paragraphs (<p>&nbsp;</p>, <p><br></p>) of the old editor: hidden, the headings keep the rhythm */
    $all('p', rte).forEach(function (p) {
      if (!norm(p.textContent) && !p.querySelector('img, iframe, video, input, a')) p.classList.add('v7p-blank');
    });

    var items = [];
    $all('h2, h3, h4, p', rte).forEach(function (h) {
      if (h.closest('li, table, td')) return;
      var t = norm(h.textContent);
      if (t.length < 3 || t.length > 90) return;
      if (h.nodeName === 'P') {
        if (boldText(h) !== t || /[:;,]$/.test(t)) return;
      }
      if (/^wersja\b/i.test(t)) return;
      var label = t;
      /* a one-word title ("REGULAMIN") followed by its full name on the next line: use the full name in the list */
      if (label.indexOf(' ') === -1) {
        var nx = h.nextElementSibling;
        var nt = nx ? norm(nx.textContent) : '';
        if (nt && nt.length <= 90 && nt === nt.toUpperCase() && nt.indexOf(label) === 0) label = nt;
      }
      if (h.nodeName === 'P') {
        h.classList.add('v7p-legal__h');
        if (t === t.toUpperCase()) h.classList.add('is-caps');
      }
      if (!h.id) h.id = 'v7p-s' + (items.length + 1);
      items.push({ el: h, label: niceLabel(label) });
    });
    /* the first visible line sits right under the title block (the old text often starts with spacers) */
    var firstEl = $all('h1, h2, h3, h4, p, ol, ul, div', rte).filter(function (n) {
      return !n.classList.contains('v7p-blank') && norm(n.textContent) && !n.querySelector('h1, h2, h3, h4, p, ol, ul, div');
    })[0];
    if (firstEl) firstEl.style.marginTop = '0';
    if (items.length < 2) return;

    items.forEach(function (it) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'v7p-toc__a';
      a.href = '#' + it.el.id;
      a.textContent = it.label;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        it.el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + it.el.id);
        if (window.matchMedia('(max-width: 899px)').matches) box.open = false;
      });
      it.a = a;
      li.appendChild(a);
      list.appendChild(li);
    });
    box.hidden = false;
    var mq = window.matchMedia('(min-width: 900px)');
    function syncOpen() { box.open = mq.matches; }
    syncOpen();
    if (mq.addEventListener) mq.addEventListener('change', syncOpen);

    /* "you are here": the last heading above the top third of the screen */
    var current = null;
    function mark() {
      var line = window.innerHeight * 0.3;
      var pick = items[0];
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= line) pick = items[i]; else break;
      }
      if (pick === current) return;
      if (current) current.a.removeAttribute('aria-current');
      current = pick;
      current.a.setAttribute('aria-current', 'true');
      /* keep the highlighted line visible inside a long, scrolling list (desktop) */
      if (mq.matches && list.scrollHeight > list.clientHeight) {
        var top = current.a.offsetTop - list.offsetTop;
        if (top < list.scrollTop || top > list.scrollTop + list.clientHeight - 44) list.scrollTop = Math.max(0, top - 80);
      }
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; mark(); });
    }, { passive: true });
    mark();
  }

  function init() { initTorty(); initGaleria(); initLegal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* theme editor: a re-rendered section comes back without data-v7p-ready, so init() wires it again */
  document.addEventListener('shopify:section:load', init);
})();
